import { Frequency } from '../models/frequency.model';
import { TrashAndRecyclingFrequency } from '../models/service-details.model';
import { frequencyOrder } from './frequency-order';

export const sortFrequency = (frequencyOptions: Frequency[]): Frequency[] => {
  return frequencyOptions.sort((a, b) => frequencyOrder[b] - frequencyOrder[a]);
};

export const sortTrashAndRecyclingFrequency = (
  frequencyOptions: TrashAndRecyclingFrequency[],
): TrashAndRecyclingFrequency[] => {
  return frequencyOptions.sort((a, b) => {
    const trashDiff = frequencyOrder[b.trashFrequency] - frequencyOrder[a.trashFrequency];
    if (trashDiff !== 0) {
      return trashDiff;
    }
    return frequencyOrder[b.recyclingFrequency] - frequencyOrder[a.recyclingFrequency];
  });
};
